import React, { Fragment, useState } from "react";
import { CiReceipt } from "react-icons/ci";
import {
  Table as TableChakra,
  TableContainer,
  Thead,
  Tbody,
  Th,
  Tr,
  Td,
  useMediaQuery,
} from "@chakra-ui/react";
import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
} from "@chakra-ui/react";
import { _t } from "content";
import dayjs from "dayjs";
import api from "services/api";
import "../style.scss";

const formatDate = (date: string) => {
  return dayjs(date).format("DD/MM/YYYY");
};

export const Table = ({
  columns,
  data,
}: any) => {
  const [isMobileSize] = useMediaQuery("(max-width: 992px)");
  const [openDetail, setOpenDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState<any>('');
  const [itemDetail, setItemDetail] = useState<any>({});

  const color = isMobileSize ? "transparent" : "#10125A";

  const detail = async (id: number) => {

    try {
      const {data} = await api.get(`/produto/notaFiscal/selecionar?id=${id}`)  
      setDataDetail(JSON.stringify(data, null, 2));
      setItemDetail(data);
    } catch (error: any) {
      if (error.response && error.response.data) {
        setDataDetail(JSON.stringify(error.response.data, null, 2));
      } else {
        setDataDetail(JSON.stringify({error: error.message, stack: error.stack}, null, 2));
      }
    } finally {
      setOpenDetail(true)
    }

    
  }

  return (
    <>
      <ChakraModal size={isMobileSize ? "full" : "5xl"}
          isOpen={openDetail}
          onClose={() => setOpenDetail(false)} 
          >
        <ModalOverlay />
        <ModalContent>
          <ModalBody >
            <ModalCloseButton />
            <div className="detail-item" style={{width: '100%'}}>
              <span className="detail-title">
                Detalhes do cupom # {itemDetail.id}
              </span>
              {(itemDetail && itemDetail.emitente) ?
              <>
                <div className="detail-header">
                  <label>Emitente:</label>
                  <div>{itemDetail.emitente.razao_social}</div>
                </div>
                <div className="detail-header">
                  <label>Cnpj:</label>
                  <div>{itemDetail.emitente.cnpj}</div>
                </div>
                <div className="detail-header">
                  <label>Nota fiscal:</label>
                  <div> {itemDetail.nf_num}</div>
                </div>
                <div className="detail-header">
                  <label>Data:</label>
                  <div>{itemDetail.data}</div>
                </div>
                <div className="detail-header">
                  <label>Situação:</label>
                  <div>{itemDetail.farmapontosMensagem}</div>
                </div>
                {itemDetail.itens && itemDetail.itens.length > 0 && (
                  <div>
                    <span className="detail-title">
                      Produtos
                    </span>
                    {itemDetail.itens.map((item: any, index: number) => (
                      <div className="prod-item" key={index}>
                        <div className="prod-text">código:&nbsp;&nbsp; {item.quantidade} x {item.codigoRede} [{item.ean || 'indeterminado'}]</div>
                        <div className="prod-text">produto:&nbsp; {item.nome}</div>
                        <div className="prod-text">situação: {item.status}</div>
                        <div className="prod-text">pontos:&nbsp;&nbsp; {item.ponto}</div>
                      </div>
                    ))}
                  </div>
                )}
                <div className="detail-chave-acesso">
                  <label>Chave acesso:</label>
                  <div>{itemDetail.chaveAcesso}</div>
                </div>
              </>
              : 
              <div className="monitorCSS" style={{minHeight: '500px', maxHeight: '500px', overflowY: 'auto', width: '100%'}}>
                {dataDetail}
              </div>
              
            } 
            
            </div>
          </ModalBody>
        </ModalContent>
      </ChakraModal>
      <TableContainer
        marginRight={!isMobileSize ? "10px" : "none"}
        maxHeight="596px"
        overflowY="auto"
        overflowX={isMobileSize ? "auto" : "hidden"}
        sx={{
          "&::-webkit-scrollbar-thumb": {
            background: color,
            borderRadius: "24px",
          },
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            width: "1px",
          },
        }}
      >
        <TableChakra
          size={isMobileSize ? "sm" : "md"}
          maxWidth="1132px"
          minWidth="335px" 
          variant="striped"
          colorScheme="gray"
        >
          <Thead backgroundColor={_t.color2}>
             
            <Tr>
              {columns.map((column, index) => (
                  <Fragment key={index}>
                    <Th
                      textTransform="capitalize"
                      fontSize="15"
                      color="#FFFF"
                    >
                      {column.Header}
                    </Th>
                  </Fragment>
                ))}
            </Tr>
          </Thead>
          <Tbody>
            {data.map((row: any, index) => {
                return (
                    <Tr
                      key={index}
                      fontSize="15"
                      fontWeight="normal"
                      color="#636262"
                    >
                      <Td>
                        <a style={{cursor: 'pointer'}} onClick={() => detail(row.id)}><CiReceipt size={30} color="#2401ec" /></a>
                      </Td>
                      <Td>
                        # {row.id}
                      </Td>
                      <Td>
                        {formatDate(row.dataInclusao)}
                      </Td>
                      <Td>
                        {row.mensagemStatus}
                      </Td>
                      <Td>
                        {row.processamentoStatus?.descricao}
                      </Td>
                    </Tr>
                );
              })}
          </Tbody>
        </TableChakra>
      </TableContainer>
      
    </>
  );
};
